import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { typeInputTyping } from '../../../../../../common/datePicker/constants'
import InputSingleDate from '../../../../../../common/datePicker/InputSingleDate'
import InputTypingDate from '../../../../../../common/datePicker/InputTypingDate'
import { UseI18n } from '../../../../../../common/hooks/useI18n'
import { Element } from '../../../../../../common/html/element'
import { Icon } from '../../../../../../common/html/icon'
import { MAX_CONDITION } from '../../../../common/constant'
import { ErrorMessage } from '../../../../common/errorMessage'
import { getCurrentTime } from '../../../../common/helper'
import { selectScreeningIndicatorById } from '../../../../common/store/slice'
import { changeCriteria, selectCriteria } from '../../../store/slice'
import { DeleteAddButtons } from '../deleteAddButtons'
import classes from './index.module.scss'

export const Item = ({
  criteriaGroup,
  screeningIndicatorId,
  conditionId,
  hasAddBtn,
  conditionsLength,
}) => {
  const dispatch = useDispatch()

  const timeoutRef = useRef()

  const maxMultiple =
    useSelector(
      selectScreeningIndicatorById(screeningIndicatorId, 'maxMultiple'),
    ) || MAX_CONDITION

  const conditionData = useSelector(
    selectCriteria([criteriaGroup, screeningIndicatorId, 'data', conditionId]),
  )

  const [isShowMaxMessage, setIsShowMaxMessage] = useState(false)

  const onAddBtnClick = () => {
    if (conditionsLength >= maxMultiple) {
      setIsShowMaxMessage(true)
      clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => {
        setIsShowMaxMessage(false)
      }, 3000)
      return
    }

    const id = getCurrentTime()
    dispatch(
      changeCriteria({
        path: [criteriaGroup, screeningIndicatorId, 'data', id],
        data: { id, from: '', to: '' },
      }),
    )
  }

  const onDeleteBtnClick = () => {
    if (conditionsLength === 1) {
      dispatch(
        changeCriteria({
          path: [criteriaGroup, screeningIndicatorId, 'data', conditionId],
          data: { id: conditionId, from: '', to: '' },
        }),
      )
    } else {
      dispatch(
        changeCriteria({
          path: [criteriaGroup, screeningIndicatorId, 'data', conditionId],
          data: undefined,
        }),
      )
    }
  }

  const resetError = () => {
    if (conditionData.error) {
      dispatch(
        changeCriteria({
          path: [
            criteriaGroup,
            screeningIndicatorId,
            'data',
            conditionId,
            'error',
          ],
          data: undefined,
        }),
      )
    }
  }

  const onFromChange = (value) => {
    resetError()
    dispatch(
      changeCriteria({
        path: [
          criteriaGroup,
          screeningIndicatorId,
          'data',
          conditionId,
          'from',
        ],
        data: value,
      }),
    )
  }

  const onToChange = (value) => {
    resetError()
    dispatch(
      changeCriteria({
        path: [criteriaGroup, screeningIndicatorId, 'data', conditionId, 'to'],
        data: value,
      }),
    )
  }

  return (
    <>
      <Element className={classes.item}>
        <Element className="flex1 minW0 mr1">
          <InputSingleDate
            defaultDate={
              conditionData.from ? new Date(conditionData.from) : undefined
            }
            onSubmit={onFromChange}
          >
            <Element
              className={classes.inputTypingDate}
              style={{ borderColor: '#E0E0E0' }}
            >
              <InputTypingDate
                date={conditionData.from}
                onChange={onFromChange}
                typeInput={typeInputTyping.SINGLE_DATE}
                placeholder={UseI18n('screening.FROM_DATE_PLACEHOLDER')}
                style={{ border: 'none', outline: 'none' }}
                defaultFocus
              />
              <Icon
                className="icon-calendar"
                style={{ fontSize: 16, color: '#9C9C9C' }}
              />
            </Element>
          </InputSingleDate>
        </Element>
        <Element className="flex1 minW0">
          <InputSingleDate
            defaultDate={
              conditionData.to ? new Date(conditionData.to) : undefined
            }
            onSubmit={onToChange}
          >
            <Element
              className={classes.inputTypingDate}
              style={{ borderColor: '#E0E0E0' }}
            >
              <InputTypingDate
                date={conditionData.to}
                onChange={onToChange}
                typeInput={typeInputTyping.SINGLE_DATE}
                placeholder={UseI18n('screening.TO_DATE_PLACEHOLDER')}
                style={{ border: 'none', outline: 'none' }}
              />
              <Icon
                className="icon-calendar"
                style={{ fontSize: 16, color: '#9C9C9C' }}
              />
            </Element>
          </InputSingleDate>
        </Element>
        <DeleteAddButtons
          showAddBtn={hasAddBtn}
          onAddBtnClick={onAddBtnClick}
          onDeleteBtnClick={onDeleteBtnClick}
        />
      </Element>
      {conditionData.error && <ErrorMessage value="screening.REQUIRED_MESS" />}
      {hasAddBtn && isShowMaxMessage && (
        <ErrorMessage
          value="screening.MAX_CONDITION_MESS"
          max={maxMultiple}
          className="mt1"
        />
      )}
    </>
  )
}
